/* ═══════════════════════════════════════════════════════════════════════
   FizzyIQ — Comparison table. The marks fade in column by column
   (left → right) every time the table scrolls into view, and reset when it
   scrolls out so the animation replays on each re-entry (Sam 2026-06-07).
   The .cmp--anim class is added by JS so that, with JS off, the marks are
   simply visible (no permanent hidden state).
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__fizzyCompareBooted) return;
  window.__fizzyCompareBooted = true;

  function boot() {
    var tables = document.querySelectorAll('.cmp');
    Array.prototype.forEach.call(tables, function (cmp) {
      cmp.classList.add('cmp--anim');
      if (!('IntersectionObserver' in window)) {
        cmp.classList.add('is-revealed');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            cmp.classList.add('is-revealed');     // play in
          } else {
            cmp.classList.remove('is-revealed');  // reset so it replays next time
          }
        });
      }, { threshold: 0.25 });
      io.observe(cmp);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
